import { render, staticRenderFns } from "./TrafficMessageRevisionSelect.vue?vue&type=template&id=5a0f3da1"
import script from "./TrafficMessageRevisionSelect.vue?vue&type=script&lang=js"
export * from "./TrafficMessageRevisionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports